module.exports = __webpack_public_path__ + "img/1726037011880-screenshot-1726036946459.png.717fbfe3.webp";